import Icon from "assets/icons";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import useHeaderService from "./service";
import { useParticipantDetails } from "../../context/participantDetails";
import React from "react";
import { MyExpRoute } from "../../routes/types";
import { useLocation } from "react-router-dom";
import HeaderLogo from "./headerLogo";
import MyActions from "../myActions";
import Variant from "shared/enums/Variant";
import MyPrivileges from "../myPrivileges";
import UserDropdown from "shared/components/userDropdown";
import useMyExpUserDropdownService from "./hooks/useDropdownService";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";
import { AnalyticsEventNameEnum, AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";
import AnalyticsDatastoreType from "shared/enums/AnalyticsDatastoreType";

export function Header() {
  const service = useHeaderService();
  return (
    service.isUserLoggedIn && (
      <header className="myExpheader">
        <div className="myExpheader_wrapper">
          <div className="myExpheader_left">
            <HeaderLogo />
          </div>
          <div className="myExpheader_right">
            <div className="myExpheader_right--title">{service.isUserLoggedIn && <MiddleContentForLoggedInUser />}</div>
            <div className="myExpheader_right--actions">{service.isUserLoggedIn && <RightActionForLoggedInUser />}</div>
          </div>
        </div>
      </header>
    )
  );
}

function MiddleContentForLoggedInUser() {
  const { screenName } = useParticipantDetails();
  const copies = useCopies();
  return (
    <div className="myExpheader_title_wrapper">
      <span className="myExpheader_title_text">{screenName ? screenName : copies.get("myexp.label")}</span>
    </div>
  );
}

function RightActionForLoggedInUser() {
  const copies = useCopies();
  const location = useLocation();
  const { logEvent } = useMyExpAnalytics();
  const { participantDetails } = useParticipantDetails();
  const service = useHeaderService();
  const dropdownService = useMyExpUserDropdownService();

  return (
    <React.Fragment>
      <ul className="list-unstyled">
        <MyActions key={location.pathname} />
        {service.showHomeButton && (
          <li>
            <Button
              className="home_redirection"
              onClick={service.navigateToHome}
              icon={<Icon.Home />}
              label={copies.get("home")}
              variant={Variant.LINK}
            />
          </li>
        )}
        {participantDetails?.faqPublished && location.pathname !== MyExpRoute.FAQ.path && (
          <li>
            <Button
              icon={<Icon.Faq />}
              label={copies.get("faq.label")}
              onClick={() => {
                logEvent(
                  AnalyticsEventNameEnum.SCREEN_VIEW,
                  {
                    screenType: AnalyticsScreenNameEnum.FAQ
                  },
                  AnalyticsDatastoreType.MIXPANEL_BUSINESS
                );
                window.open(MyExpRoute.FAQ.path, "_blank");
              }}
              className="faq_btn"
              variant={Variant.LINK}
            />
          </li>
        )}
        <MyPrivileges />
        <li>
          <UserDropdown
            showProfilePicture
            profilePictureLocation={dropdownService.profilePictureLocation}
            dropdownItemList={dropdownService.dropdownItemList}
          />
        </li>
      </ul>
    </React.Fragment>
  );
}
